import { Attachment } from "./attachment.interface";
import { Permission, Role } from "./role.interface";
import { Point } from "./point.interface";
import { UserAddress } from "./user.interface";

export interface AccountUser {
    id: number;
    name: string;
    email: string;
    phone: string;
    country_code: string;
    profile_image?: Attachment;
    profile_image_id?: number;
    status: boolean;
    email_verified_at: string;
    role_id: number;
    role_name?: string;
    role?: Role;
    permission: Permission[];
    address?: UserAddress[];
    point?: Point;
    orders_count: number;
    is_approved: boolean;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
}

export interface AccountUserUpdatePassword {
    current_password: string;
    new_password: string;
    confirm_password: string;
}

export class BusinessProfile {
    userName: string;
    businessType: string;
    businessName: string;
    taxCode: string;
    province: string;
    district: string;
    ward: string;
    address: string;
    businessLicenses: File[] = [];
    businessCertifications: File[] = [];
    distributionCertifications: File[] = [];
}

export interface DocumentData {
    documentNo?: string;
    issuedDate?: string;
    issuedPlace?: string;
}

export interface DocumentDataGPP extends DocumentData {
    expireDate?: string;
    businessScopes?: BusinessScope[];
}

export enum BusinessScope {
    GeneralProduct = 0, //TBYT, TPCN, Dược Mỹ Phẩm
    RegularNonPrescription = 1, //Thuốc thường không kê đơn
    RegularPrescription = 2, //Thuốc thường kê đơn
    EssentialPrescriptionDrug = 3, //Thuốc thường kê đơn thiết yếu
    NarcoticCombinationPrescription = 4, //Thuốc phối hợp chứa dược chất gây nghiện kê đơn
    NarcoticCombinationNonPrescription = 5, //Thuốc phối hợp chứa dược chất gây nghiện không kê đơn
    PsychotropicCombinationPrescription = 6, //Thuốc phối hợp chứa dược chất hướng thần kê đơn
    PsychotropicCombinationNonPrescription = 7, //Thuốc phối hợp chứa dược chất hướng thần không kê đơn
    PrecursorCombinationPrescription = 8, //Thuốc phối hợp chứa tiền chất  kê đơn
    PrecursorCombinationNonPrescription = 9, //Thuốc phối hợp chứa tiền chất không kê đơn
    ProhibitedInIndustriesPrescription = 10, //Thuốc cấm sử dụng trong 1 số ngành kê đơn
    ProhibitedInIndustriesNonPrescription = 11, //Thuốc cấm sử dụng trong 1 số ngành không kê đơn
    EssentialProhibitedInIndustriesPrescription = 12, //Thuốc cấm sử dụng trong 1 số ngành kê đơn thiết yếu
    BiologicProduct = 13, //Sinh phẩm
}